/**
 * Sauder village calendar. 
 * 1.0 - Initial
 * 1.01 - ??
 * 1.02 - ??
 * 1.03 - 12/30/19 
 * 
 * 1.03 - Added some documentation 
 *      - Modded filters.init to accept a default category to be REMOVED.
 *      - Added update caledar url after filters are initilized. 
 *      By default it was never planned to add filters on load. Moved the filters init to the caledar init with the categories they want removed removed. 
 *      - Add CTA at the bottom of the daily event list to add the Ongoing Classes filter to see special experiences at Sauder Village
 *      
 * */

//var queryString = new URLSearchParams(window.location.search); // This does nothing and is breaking calendar in Internet Explorer, commenting out... - DJK

var custom = {
    filters: {
        category: ['special-event', 'classes', 'daily-events', 'retreat', 'ongoing-classes'],     
        location: ['barn-events', 'campground', 'founders-hall', 'historic-village', 'retail-shops', 'sauder-heritage-inn', 'doughbox-bakery'],
    }
};

var reiEvents = {
    state: null,
    loadingIcon: '<span class="loading"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading</span>',

    init: function () {
        reiEvents.state = {
            filters: {}, //this will get filled with a copy of custom.filters, with two arrays selected and available to track the state
            date: reiEvents.getDateFromUrl(),
            //events: [],
            calendar: null,
        };

        if (!reiEvents.state.date || reiEvents.state.date === undefined) {
            console.error("The url has an invalid date query string, switching to now()");
            reiEvents.state.date = moment(); //set the search date to now().
        }
        
        reiEvents.calendar.init(); //inits filters and calendar       
      
        reiEvents.featuredEvents.init(function () {
            // This must be done after the Featured Events are initialized to determine proper height of the page offset
            reiEvents.filters.setMobileFilterScroll();
        });

        reiEvents.setPopState();
    },

    update: function () {
        window.console.log('%cApp:', 'color: #ff9328', 'Global update', reiEvents.state);
        reiEvents.calendar.updateView();
        reiEvents.agenda.daily.update();
        reiEvents.agenda.monthly.update();
    },

    api: {
        getEvents: function (month, day, year, duration, description, callback) { // Ben added
            //There are two possibilities of getting data from our web api service
            //1) Month + year is specified. This will return a list of events for that month.
            //2) Month + day + year. This will return a list events for that day.
            if (isNaN(month) || month < 0) { //check
                console.error("You need to pass in a non-zero month parameter to get events"); // Anna changed, it was conole
                return false;
            }
            if (isNaN(year) || year < 0) {     //check
                console.error("You need to pass in a non-zero year parameter to get events"); //Anna changed, it was conole
                return false;
            }
            if (isNaN(duration) || duration > 365) {
                console.error("You need to pass in a duration less than 365 days");
                return false;
            }
            if (isNaN(day) || day < 0) { day = 0; } //Get a monthly view

            //Setup our service data object to make the next call to getJSON a little cleaner.
            var servicedata = {
                SelectedDay: day,
                SelectedMonth: month,
                SelectedYear: year,
                Duration: duration,
                GetDescription: description //Get Summary, Description, & Content. Essentially doubles the size of the request payload if true.
            };

            //Get our json object from our service. The callback will pass back the event data for whatever view you requested.
            $.getJSON("/api/EventCalendar/GetEvents", servicedata, function (jsondata) {
                if (typeof callback === 'function') {
                    callback(jsondata);
                }
            });
        },
    },

    calendar: {
        init: function () {
            var $calendar = reiEvents.state.calendar = $('#fullcalendar');
            var firstLoad = false;
            reiEvents.filters.init("ongoing-classes"); //initilize our filters. remove these categories from the default.

            $calendar.fullCalendar({
                defaultDate: reiEvents.state.date,
                header: {
                    left: 'prev',
                    center: 'title',
                    right: 'next'
                },
                buttonIcons: {
                    prev: 'fa fa-chevron-left',
                    next: 'fa fa-chevron-right',
                },
                height: 'auto',
                unselectAuto: false,
                dayClick: function (date, jsEvent, view) {
                    reiEvents.calendar.selectDay(date, $calendar);
                },
                viewRender: function (view, element) {
                    reiEvents.agenda.monthly.update(moment(view.title, 'MMMM YYYY'));
                },
                eventAfterAllRender: function (view) { // Triggered after all events have finished rendering.
                    if (!firstLoad) {
                        var lastWeek = moment(view.intervalStart).subtract(7, 'days');

                        var currentYear = parseInt(moment().format('YYYY'));
                        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                        var yearOffset = 3;

                        var $headerCenter = $('.fc-toolbar .fc-center');
                        var $jumpTo = $('<aside class="jump-to-month">');
                        var $formGroup = $('<form id="jump-to-month-form">');
                        var $monthSelect = $('<select name="month">');
                        var $yearSelect = $('<select name="year">');

                        reiEvents.calendar.selectDay(reiEvents.state.date);

                        for (var i = 1; i <= months.length; i++) {
                            var monthDigit = (i < 10) ? '0' + i : i;
                            var currMonth = (monthDigit == reiEvents.state.date.format('M')) ? 'selected' : '';
                            $monthSelect.append('<option value="' + monthDigit + '" ' + currMonth + '>' + months[i - 1] + '</option>');
                        }

                        for (var j = yearOffset; j >= 0; j--) {
                            var currYear = (currentYear - j == reiEvents.state.date.format('YYYY')) ? 'selected' : '';
                            $yearSelect.append('<option value="' + (currentYear - j) + '" ' + currYear + '>' + (currentYear - j) + '</option>');
                        }

                        $jumpTo.append($formGroup.append($monthSelect).append($yearSelect)).append('<a onclick="reiEvents.calendar.jumpToMonth($(\'#jump-to-month-form select[name=month]\').val(), $(\'#jump-to-month-form select[name=year]\').val()); $(\'.fc-toolbar .fc-center\').toggleClass(\'show-jump-to\');">Go</a>');

                        $headerCenter.append($jumpTo).addClass('has-jump-to');

                        $headerCenter.find('h2').click(function () {
                            $headerCenter.toggleClass('show-jump-to');
                        });

                        firstLoad = true;
                    }
                }
            });

            if (reiEvents.helpers.isMobile()) {
                $('.fc-content-skeleton td').click(function () {
                    var date = moment($(this).attr('data-date'), 'YYYY-MM-DD');
                    reiEvents.calendar.selectDay(date);
                });
            }
        },

        selectDay: function (date, $calendar, updateUrl) {
            window.console.log('%cCalendar', 'color: #ffdc51', 'Date Selected: "' + date.format('YYYY-MM-DD') + '"');

            var month = date.get('month') + 1; //month is zero based for moment.js
            var day = date.get('date');
            var year = date.get('year');

            reiEvents.agenda.daily.update(date);

            // If clicked month is different than current date's month, update the Monthly Agenda View
            //if (!date.isSame(reiEvents.state.date, "month") || !reiEvents.state.events.length) {

            date = (date === undefined) ? moment() : date;
            updateUrl = (updateUrl === undefined) ? true : updateUrl;
            $calendar = ($calendar === undefined) ? reiEvents.state.calendar : $calendar;

            var dataDate = date.format('YYYY-MM-DD');
            //console.log('before goToDate', date);
            $calendar.fullCalendar('gotoDate', date);
            //console.log('after goToDate', date);
            $calendar.fullCalendar('select', date);
            //console.log('after select', date);
            //console.log('before fc-selected stuff', dataDate);
            $('.fc-selected').removeClass('fc-selected');
            $('td[data-date="' + dataDate + '"]').addClass('fc-selected');

            reiEvents.setCurrentDate(date);

            //reiEvents.filters.apply();

            if (updateUrl) reiEvents.updateCalendarUrl(date);
        },

        jumpToMonth: function (month, year) {
            //var date = moment(year + '/' + month + '/' + reiEvents.state.date.format('DD'), 'YYYY/MM/DD');
            var date = moment(year + '/' + month + '/01', 'YYYY/MM/DD'); //If you jump a month, set the first day to be selected to prevent any oddities like feb 31.
            reiEvents.calendar.selectDay(date);
        },

         /**
          *  updateView - Puts dots on the calendar for events
          *  
           * */
        updateView: function (date, $calendar) {
            $calendar = ($calendar === undefined) ? reiEvents.state.calendar : $calendar;
            date = (date === undefined) ? moment($calendar.fullCalendar('getView').title, 'MMMM YYYY') : date;

            // Always remove dots in order to re-add a fresh set
            $('ul.dots').remove();

            reiEvents.api.getEvents(date.format('MM'), 0, date.format('YYYY'), 0, true, function (events) {
                var count = 0;

                /*
                 * Puts dots on the calendar for events
                 * */
                events.forEach(function (event) {
                    if (reiEvents.event.isValid(event)) {
                        var date = moment(event.occurance_start_date);
                        var tags = event.tags;
                        var types = [];

                        var $td = $calendar.find('.fc-content-skeleton td[data-date="' + date.format('YYYY-MM-DD') + '"]');
                        var $dots = $td.find('.dots');

                        // If not dots <ul>, add one
                        if (!$dots.length) {
                            $dots = $('<ul class="dots plain group">');
                        }

                        tags.forEach(function (tag) {
                            var t = reiEvents.helpers.normalizeText(tag);
                            if (reiEvents.state.filters.category.available.indexOf(t) >= 0) {
                                types.push(t);
                            }
                        });

                        types.forEach(function (type) {
                            if (!$dots.find('li.' + type).length) {
                                $dots.append($('<li class="sv-icon dot ' + type + '">'));
                                count++;
                            }
                        });

                        $td.prepend($dots);
                    }

                    $calendar.removeClass('loading');
                });

                window.console.log('%cCalendar', 'color: #ffdc51', 'View update with ' + count + ' events on "' + date.format('YYYY-MM-DD') + '"');
            });
        },
    },

    
    filters: {
        /**
         * Filters initilizer.
         * Looks for querystring based filters and applies filters to a state object. 
         * @param {string} defaultCategories - a csv off default categories to be deselected on init. 
         * */
        init: function (defaultCategories) {
            var filters = reiEvents.state.filters; //There are N types of filters. category and location. 

            for (var key in custom.filters) { //Key will be 'category' or 'location', custom.filters is a global object.
                var queryStr = reiEvents.helpers.getQueryStringKeyByName(key); //get the values associated with a filter key.  This should be a csv. 

                //if there is no default set it. 
                if (key == 'category' && queryStr == null) { //set 
                    queryStr = defaultCategories; //this will hide this category
                }

                filters[key] = {};
                filters[key].available = _.clone(custom.filters[key]);
                //filters[key].selected = _.clone(custom.filters[key]);
                //if there is something in the query string 
                filters[key].selected = (queryStr !== null) ? _.difference(_.clone(custom.filters[key]), queryStr.split(',')) : _.clone(custom.filters[key]);
            }

            window.console.log('%cFilters:', 'color: #37bdf2', 'Initialized', filters);

            // Set clear filter buttons
            $('.event-location .clear-filters').click(function () {
                reiEvents.filters.clear('location');
            });

            $('.event-type .clear-filters').click(function () {
                reiEvents.filters.clear('category');
            });

            // Based on the URL, preset categories
            var urlPathArr = window.location.pathname.split('/');
            urlPathArr.forEach(function (dir) {
                if (dir == 'classes') {
                    reiEvents.filters.clear('category');
                    reiEvents.filters.update('category', 'classes');
                } else if (dir == 'special-events' || dir == 'events') {
                    reiEvents.filters.clear('category');
                    reiEvents.filters.update('category', 'special-event');
                }
            });

            // Based on the set categories, preset title references
            reiEvents.filters.updateTitles();

            // Preset filter inputs
            reiEvents.filters.updateInputs();

            // Filter input change events
            reiEvents.filters.setInputs();

            reiEvents.state.filters = filters;
        },

        update: function (type, filter, updateUrl) {
            updateUrl = (updateUrl === undefined) ? true : updateUrl;

            var filters = reiEvents.state.filters;

            if (type !== undefined && type !== "" && filter !== undefined && filter !== "") {
                for (var key in filters) {
                    if (reiEvents.helpers.normalizeText(key) === reiEvents.helpers.normalizeText(type)) {
                        if (filters[key].selected.indexOf(filter) >= 0) {
                            window.console.log('%cFilters:', 'color: #37bdf2', 'Removing "' + filter + '"');
                            filters[key].selected.splice(filters[key].selected.indexOf(filter), 1);
                        } else {
                            window.console.log('%cFilters:', 'color: #37bdf2', 'Adding "' + filter + '"');
                            filters[key].selected.push(filter);
                        }

                        reiEvents.state.filters = filters;
                    }
                }

                if (updateUrl) reiEvents.updateCalendarUrl(reiEvents.state.date);

                reiEvents.update();
                //reiEvents.filters.apply();
            } else {
                window.console.error('reiEvents.filters.update(): You must provide a filter type');
            }
        },

        clear: function (type) {
            for (var key in reiEvents.state.filters) {
                var filter;
                var filters = reiEvents.state.filters[key];

                if (type !== undefined && type !== "") {
                    if (reiEvents.helpers.normalizeText(key) === reiEvents.helpers.normalizeText(type)) {
                        window.console.log('%cFilters:', 'color: #37bdf2', 'Cleared type "' + type + '"');

                        for (var i = 0; i < filters.available.length; i++) {
                            filter = filters.available[i];

                            if (filters.selected.indexOf(filter) >= 0) {
                                reiEvents.filters.update(type, filter);
                            }
                        }
                    }
                } else {
                    window.console.log('%cFilters:', 'color: #37bdf2', 'Cleared all');

                    for (var j = 0; j < filters.available.length; j++) {
                        filter = filters.available[j];

                        if (filters.selected.indexOf(filter) < 0) {
                            reiEvents.filters.update(type, filter);
                        }
                    }
                }
            }

            reiEvents.filters.updateInputs();
        },

        setInputs: function () {

            var filters = reiEvents.state.filters;
            var $inputs = $('input.filter');

            $inputs.change(function () {
                var value = $(this).val();

                window.console.log('%cFilters:', 'color: #37bdf2', 'Clicked "' + value + '"');

                reiEvents.filters.update($(this).attr('data-filter-type'), value);
                reiEvents.filters.updateTitles();
            });
        },

        updateInputs: function () {
            var filters = reiEvents.state.filters;
            var $inputs = $('input.filter');

            for (var key in filters) {
                for (var i = 0; i < filters[key].available.length; i++) {
                    if (filters[key].selected.indexOf(filters[key].available[i]) >= 0) {
                        $inputs.filter('[value="' + filters[key].available[i] + '"]').attr('checked', true);
                    } else {
                        $inputs.filter('[value="' + filters[key].available[i] + '"]').attr('checked', false);
                    }
                }
            }
        },

        updateTitles: function () {
            var filters = reiEvents.state.filters;
            var $titleTypes = $('.title span.type:not(.nofilter)');

            if (filters.category.selected.indexOf('special-event') >= 0 && filters.category.selected.indexOf('classes') < 0) {
                $titleTypes.text('Events');
            } else if (filters.category.selected.indexOf('special-event') < 0 && filters.category.selected.indexOf('classes') >= 0) {
                $titleTypes.text('Classes');
            } else {
                $titleTypes.text('Special Events & Classes');
            }
        },

        setMobileFilterScroll: function () {
            // Mobile calendar jump-to
            var filterTop = $('.calendar-and-filters').offset().top;
            var filterHeight = $('.calendar-and-filters').outerHeight();

            if (reiEvents.helpers.isMobile()) {
                $('#mobile-jump-to-calendar').click(function () {
                    $('html, body').animate({
                        scrollTop: $('.calendar-and-filters').offset().top - 10
                    }, 1000);
                });

                $(window).scroll(function () {
                    if ($(window).scrollTop() > filterTop + filterHeight) {
                        $('#mobile-jump-to-calendar').slideDown();
                    } else {
                        $('#mobile-jump-to-calendar').slideUp();
                    }
                });
            }
        },
    },

    agenda: {
        daily: {
            update: function (date) {
                date = (date === undefined) ? reiEvents.getCurrentDate() : date;

                var html = '';
                var localEvents = false;
                var $agendaBox = $('.daily-agenda');
                var $eventlist = $agendaBox.find('ul.events-list');

                $eventlist.html($('<li>').append(reiEvents.loadingIcon));
                $agendaBox.find('header.date-scroller h3 .date-text').text(date.format('MMM. Do, YYYY'));
                $agendaBox.find('footer span.prev-date').text(moment(date).subtract(1, 'days').format('MMMM Do, YYYY'));
                $agendaBox.find('footer span.next-date').text(moment(date).add(1, 'days').format('MMMM Do, YYYY'));

                reiEvents.api.getEvents(date.format('MM'), date.format('DD'), date.format('YYYY'), 0, true, function (events) {
                    console.log('%cPull new events for "Daily Agenda"', "color: #c0ffee", events);

                    if (events.length) { //if there are events for that day
                        var closedEvents = [];
                        var validEvents = [];

                        // Closed Events
                        events.forEach(function (event) {
                            if (event.tags.indexOf("Facility Closure") >= 0) {
                                closedEvents.push(event);
                                //html += reiEvents.event.buildMarkup(event, 'simple', 'li', true)[0].outerHTML;
                            }
                        });

                        events.forEach(function (event) {
                            if (event.tags.indexOf("Facility Closure") < 0 && reiEvents.event.isValid(event)) {
                                validEvents.push(event);
                                //html += reiEvents.event.buildMarkup(event)[0].outerHTML;
                            }
                        });

                        if (validEvents.length && closedEvents.length) {
                            closedEvents.forEach(function (event) {
                                html += reiEvents.event.buildMarkup(event, 'simple', 'li', true)[0].outerHTML;
                            });
                            validEvents.forEach(function (event) {
                                html += reiEvents.event.buildMarkup(event)[0].outerHTML;
                            });
                        } else if (closedEvents.length) {
                            closedEvents.forEach(function (event) {
                                html += reiEvents.event.buildMarkup(event, 'simple', 'li', true)[0].outerHTML;
                            });
                            html += '<li class="message"><h3>No events scheduled for today.</h3></li>';
                        } else if (validEvents.length) {
                            validEvents.forEach(function (event) {
                                html += reiEvents.event.buildMarkup(event)[0].outerHTML;
                            });
                        } else {
                            var message = "There are events scheduled for today, but are being hidden by filters. Please adjust the filters to view events.";
                            html = '<li class="message"><h3>' + message + '</h3></li>';
                        }

                        $eventlist.html(html); //add the events to the event list.
                    } else {
                        var startOfNextMonth = moment(new Date(date.year(), date.month() + 1, 1));
                        var minimumNextDay = startOfNextMonth;

                        reiEvents.api.getEvents(date.format('MM'), 0, date.format('YYYY'), 0, true, function (events) {
                            events.forEach(function (event) {
                                if (date.isBefore(moment(event.occurance_start_date)) && minimumNextDay.isAfter(moment(event.occurance_start_date))) {
                                    minimumNextDay = moment(event.occurance_start_date);
                                }
                            });

                            var message = "No events scheduled for today.";

                            if (minimumNextDay != startOfNextMonth) {
                                message += ' <a id="nextEvent">Click here</a> to check the next available day with events';
                            } else {
                                message += ' <a id="nextEvent">Click here</a> to check the next month\'s events';
                            }

                            html = '<li class="message"><h3>' + message + '</h3></li>';

                            $eventlist.html(html);

                            $('#nextEvent').click(function () {
                                reiEvents.calendar.selectDay(minimumNextDay);
                            });
                        });
                    }

                });

                if (!date.isSame(reiEvents.state.date, "month")) {
                    reiEvents.agenda.monthly.update(date);
                }
            },
        },

        monthly: {
            update: function (date) {
                date = (date === undefined) ? reiEvents.getCurrentDate() : date;

                var $agendaBox = $('.monthly-agenda');
                var $eventlist = $agendaBox.find('ul.events-list');

                $eventlist.html($('<li>').append(reiEvents.loadingIcon));

                if (date.isSame(moment(), 'year')) {
                    $agendaBox.find('h2.title .month').text(date.format('MMMM'));
                } else {
                    $agendaBox.find('h2.title .month').text(date.format('MMMM YYYY'));
                }

                reiEvents.api.getEvents(date.format('MM'), 0, date.format('YYYY'), 0, true, function (events) {
                    console.log('Pull new events for "Monthly Agenda"', events);

                    var uniqueEventIds = [];
                    var html = '';

                    events.forEach(function (event) {
                        if (reiEvents.event.isValid(event) && uniqueEventIds.indexOf(event.id) < 0 && event.tags.indexOf('Facility Closure') < 0) {
                            html += reiEvents.event.buildMarkup(event)[0].outerHTML;
                            uniqueEventIds.push(event.id);
                        }
                    });

                    $eventlist.html(html);

                    //reiEvents.state.events = events;

                    reiEvents.calendar.updateView();
                });
            },
        }
    },

    featuredEvents: {
        init: function (callback) {
            var html = "";
            var today = moment();
            var featuredEvents = [];
            var filters = reiEvents.state.filters;
            var $featuredEventsList = $('.events-list.featured');
            var $title = $('.featured-events .title span.type');

            $featuredEventsList.html(reiEvents.loadingIcon);

            reiEvents.api.getEvents(today.format('MM'), today.format('DD'), today.format('YYYY'), 365, false, function (events) {
                events.forEach(function (event) {
                    if (reiEvents.event.isValid(event) && (event.tags.indexOf('Featured Calendar') >= 0 || event.tags.indexOf('Featured - Calendar') >= 0) && featuredEvents.indexOf(event.id) < 0) {
                        html += reiEvents.event.buildMarkup(event, 'slideitem nofilter', 'div')[0].outerHTML;
                        featuredEvents.push(event.id);
                    }
                });

                window.console.log('%cFeatured:', 'color: #d93ffc', 'Initialized with ' + featuredEvents.length + ' events', featuredEvents);

                $featuredEventsList.html(html);

                $featuredEventsList.slick({
                    infinite: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    prevArrow: '.slidebox .arrow.prev',
                    nextArrow: '.slidebox .arrow.next',
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                });

                if (typeof callback === 'function') {
                    callback();
                }
            });

            if (filters.category.selected.indexOf('special-event') >= 0 && filters.category.selected.indexOf('classes') < 0) {
                $title.text('Events');
            } else if (filters.category.selected.indexOf('special-event') < 0 && filters.category.selected.indexOf('classes') >= 0) {
                $title.text('Classes');
            } else {
                $title.text('Special Events & Classes');
            }
        },
    },

    event: {
        buildMarkup: function (event, addClass, wrapperElem, simpleView) {
            simpleView = (simpleView === undefined) ? false : simpleView;
            addClass = (addClass === undefined) ? '' : addClass;
            wrapperElem = (wrapperElem === undefined) ? 'li' : wrapperElem;

            var hasType = false;

            //var displayStartDate = moment(event.occurance_start_date).format('MMMM Do, YYYY');
            //var displayEndDate = moment(event.occurance_end_date).format('MMMM Do, YYYY');
            //12/30/19 - Changing the display date3s
            var displayStartDate = moment(event.start_date).format('MMMM Do, YYYY');
            var displayEndDate = moment(event.end_date).format('MMMM Do, YYYY');

            var startDateDay = moment(event.occurance_start_date).format('Do');
            var startDateMonth = moment(event.occurance_start_date).format('MMMM');
            var startDateYear = moment(event.occurance_start_date).format('YYYY');
            var endDateDay = moment(event.end_date).format('Do');
            var endDateMonth = moment(event.end_date).format('MMMM');
            var endDateYear = moment(event.end_date).format('YYYY');

            var $typeIconList = $('<span class="type-icons">');
            var $eventButton = $('<a class="button">');
            var $registration = event.registration ? $('<em class="registration">Advanced Registration Required</em>') : "";

            var thumbnail = event.thumbnailurl;

            /*if (event.reservationurl !== '') {
                $eventButton.attr('href', event.reservationurl).text('Register Now!');
            } else if (event.link !== '/' || event.link !== '') {
                $eventButton.attr('href', event.link).text('View Details');
            }*/

            // If event link is present, create button markup
            if (event.link !== '/' || event.link !== '') {
                $eventButton.attr('href', event.link).text('View Details');
            }

            // Build icon lists
            for (var filter in reiEvents.state.filters) {
                for (var i = 0; i < event.tags.length; i++) {
                    var type = event.tags[i];
                    var typeSlug = reiEvents.helpers.normalizeText(type);

                    if (reiEvents.state.filters[filter].available.indexOf(typeSlug) >= 0) {
                        hasType = true;
                        $typeIconList.append('<i class="sv-icon type ' + typeSlug + '" title="' + type + '"></i>');
                    }
                }
            }

            if (!hasType) $typeIconList = $();
            
            var $li = $("<" + wrapperElem + ">").addClass("event widget group");

            // Add filtering data- to the event <li>
            for (var key in reiEvents.state.filters) {
                var value = [];

                for (var k = 0; k < event.tags.length; k++) {
                    var tag = reiEvents.helpers.normalizeText(event.tags[k]);
                    if (reiEvents.state.filters[key].available.indexOf(tag) >= 0) {
                        value.push(tag);
                    }
                }

                if (value.length) {
                    $li.addClass(value.join(' '));
                    $li.attr('data-' + key, value.join('|'));
                }
            }

            // If addClass is passed into funciton, add it to the event <li>
            $li.addClass(addClass);

            var $article = $("<article>");

            if (simpleView) {
                $article.append('<p>' + event.name + '</p>');
                $li.append($article);
            } else {
                $article.append($('<h2><a href="' + $eventButton.attr('href') + '">' + event.name + '</a></h2>'));

                // Start and End are equal
                if (event.date_override)
                {
                    $article.append($("<h3>" + event.date_override + "</h3>"));
                }

                else if (displayStartDate == displayEndDate) {
                    $article.append($("<h3>" + displayStartDate + "</h3>"));
                }

                // Start and End are not equal
                else if (startDateYear != endDateYear) {
                    $article.append($("<h3>" + displayStartDate + " - " + displayEndDate + "</h3>"));
                }

                // Start and End are not equal and start Year and end Year are equal
                else if (startDateMonth != endDateMonth) {
                    $article.append($("<h3>" + startDateMonth + " " + startDateDay + " - " + displayEndDate + "</h3>"));
                }

                else if (startDateDay == endDateDay)
                {
                    $article.append($("<h3>" + startDateMonth + " " + startDateDay + "</h3>"));
                }

                // Start and End are not equal and start Year and end Year are equal start and end month are equal
                else {
                    $article.append($("<h3>" + startDateMonth + " " + startDateDay + " - " + endDateDay + ", " + endDateYear + "</h3>"));  //August 15th - 20th, 2016
                }

                if (thumbnail === undefined || thumbnail === null) {
                    thumbnail = '';
                }

                $article.append('<h4 class="times">' + event.times + '</h4>');

                $article.append($('<p class="summary">' + event.summary + '</p>'));
                $article.append($('<p>').append($eventButton, $typeIconList, $registration));
                $li.append($article);
                var $figure = $('<figure></figure>');
                $figure.append($('<img src = "' + thumbnail.replace('127.0.0.1', 'rei047.glpublishing.com:8084') + '" alt="Photo of ' + event.name + '"     />')); // ask if we need a default image
                $figure.append($typeIconList.clone());
                $li.prepend($figure);
            }

            return $li;
        },

        isValid: function (event) {
            var validArr = {};
            var filters = reiEvents.state.filters;
            var tags = event.tags;
            var vars = {};
            var results = {};

            for (var key in filters) {
                var count = 0;
                vars[key] = [];

                for (var i = 0; i < tags.length; i++) {
                    var tag = reiEvents.helpers.normalizeText(tags[i]);

                    if (filters[key].available.indexOf(tag) >= 0) {
                        vars[key][count] = tag;
                        count++;
                    }
                }
            }

            // Build validity array by testing event's taxonomy against the set filters
            for (var filter in vars) {
                validArr[filter] = false;

                if (vars[filter].length) {
                    for (var j = 0; j < vars[filter].length; j++) {
                        if (filters[filter].selected.indexOf(vars[filter][j]) >= 0) {
                            validArr[filter] = true;
                            break;
                        }
                    }
                } else {
                    validArr[filter] = true;
                }
            }

            var isValidEvent = true;

            // Go through validity array and if any are true, it is a successful test
            for (var k in validArr) {
                if (!validArr[k]) {
                    isValidEvent = false;
                }
            }

            return isValidEvent;
        },
    },

    updateCalendarUrl: function (date, filters) {       
        filters = (filters === undefined) ? reiEvents.state.filters : filters;

        var url = window.location.href;       
        url = reiEvents.helpers.updateQueryString(url, 'day', date.format('DD'));
        url = reiEvents.helpers.updateQueryString(url, 'month', date.format('MM'));
        url = reiEvents.helpers.updateQueryString(url, 'year', date.format('YYYY'));
       

        for (var key in filters) {
            var query = _.difference(filters[key].available, filters[key].selected);

            if (query.length) {
                url = reiEvents.helpers.updateQueryString(url, key, query.join(','));
            } else {
                url = reiEvents.helpers.removeQueryStringKeyByName(url, key);
            }
        }

        var title = 'Sauder Village Events on ' + date.format('MMMM D, YYYY');
        var state = {
            day: date.format('DD'),
            month: date.format('MM'),
            year: date.format('YYYY'),
            filters: reiEvents.state.filters,
        };

        window.history.pushState(state, title, url);
    },

    hideShowEvents: function (action, filter, operation) {
        filterClass = (filter === undefined) ? '' : '.' + filter;
        action = (action === undefined) ? 'show' : action;
        operation = (operation === undefined) ? 'inclusive' : operation;

        var $events = $('.events-list .event:not(.nofilter), .calendar ul.dots li');
        var $inputs = $('input.filter');

        if (filter !== undefined && filter !== '') {
            if (action == 'hide') {
                $events.filter(filterClass).addClass('hidden');
                $inputs.filter('[value="' + filter + '"]').attr('checked', false);
            } else {
                $events.filter(filterClass).removeClass('hidden');
                $inputs.filter('[value="' + filter + '"]').attr('checked', true);
            }
        } else {
            if (action == 'hide') {
                $events.addClass('hidden');
            } else {
                $events.removeClass('hidden');
            }
        }
    },

    getDateFromUrl: function () {
        var url = window.location.href;
        var queryStrDay = reiEvents.helpers.getQueryStringKeyByName('day', url);
        var queryStrMonth = reiEvents.helpers.getQueryStringKeyByName('month', url);
        var queryStrYear = reiEvents.helpers.getQueryStringKeyByName('year', url);
        return reiEvents.helpers.getValidDate(queryStrDay, queryStrMonth, queryStrYear);
    },

    getCurrentDate: function (dayOffset) {
        dayOffset = (dayOffset === undefined) ? 0 : dayOffset;
        return moment(reiEvents.state.date).add(dayOffset, 'days');
    },

    goToNextDay: function () {
        reiEvents.calendar.selectDay(reiEvents.getCurrentDate(1));
    },

    goToPrevDay: function () {
        reiEvents.calendar.selectDay(reiEvents.getCurrentDate(-1));
    },

    setCurrentDate: function (date) {
        reiEvents.state.date = date;
    },

    setPopState: function () {
        window.onpopstate = function (e) {
            if (e.state) {
                var selectedDate = reiEvents.helpers.getValidDate(e.state.day, e.state.month, e.state.year);
                reiEvents.calendar.selectDay(selectedDate, reiEvents.calendar, false);

                reiEvents.state.filters = (e.state.filters.length) ? e.state.filters.split(',') : [];
                //reiEvents.filters.apply();
            }
        };
    },

    helpers: {
        //Taken from https://stackoverflow.com/questions/5999118/how-can-i-add-or-update-a-query-string-parameter
        updateQueryString: function (uri, key, value) {           
            var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
            var separator = uri.indexOf('?') !== -1 ? "&" : "?";
            if (uri.match(re)) {
                return uri.replace(re, '$1' + key + "=" + value + '$2');
            } else {
                return uri + separator + key + "=" + value;
            }
        },

        getQueryStringKeyByName: function (name, url) {
            if (!url) { url = window.location.href; }
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },

        removeQueryStringKeyByName: function (url, parameter) {
            //prefer to use l.search if you have a location/link object
            var urlparts = url.split('?');
            if (urlparts.length >= 2) {

                var prefix = encodeURIComponent(parameter) + '=';
                var pars = urlparts[1].split(/[&;]/g);

                //reverse iteration as may be destructive
                for (var i = pars.length; i-- > 0;) {
                    //idiom for string.startsWith
                    if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                        pars.splice(i, 1);
                    }
                }

                url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
                return url;
            } else {
                return url;
            }
        },

        normalizeText: function (text) {
            if (text !== undefined && text !== "") {
                return text.replace(new RegExp(' ', 'g'), '-').toLowerCase();
            }

            return text;
        },

        getValidDate: function (day, month, year) {
            var date = moment();

            if (year !== null && month !== null && day !== null) {
                date = moment([year, month, day].join(''));
            }

            return (date.isValid()) ? date : false;
        },

        isMobile: function () {
            return window.innerWidth < 768;
        }
    },
};

$.fn.invert = function () {
    return this.end().not(this);
};

$(function () {
    reiEvents.init();
});
